import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-872082da")

_pushScopeId("data-v-872082da")
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "card p-fluid" }
const _hoisted_3 = { class: "p-field p-grid" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " 表示順 ", -1)
const _hoisted_5 = { class: "p-col-6 p-md-2" }
const _hoisted_6 = { class: "p-field p-grid" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " 定型文 ", -1)
const _hoisted_8 = { class: "p-col-6 p-md-10" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_zMessage = _resolveComponent("zMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: '定型文詳細',
    visible: _ctx.mDispDetail,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.mDispDetail = $event)),
    style: [{ width: '80vw'}, {"max-width":"1100px"}],
    modal: true,
    closable: false
  }, {
    footer: _withId(() => [
      (_ctx.mMODEXX == 1 || _ctx.mMODEXX == 2)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            label: "閉じる",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fncClose())),
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"}
          }))
        : _createCommentVNode("", true),
      (_ctx.mMODEXX == 3)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            label: "中止",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fncCancel())),
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"}
          }))
        : _createCommentVNode("", true),
      (_ctx.mMODEXX == 1)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 2,
            label: "修正",
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"},
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fncUpdate()))
          }))
        : _createCommentVNode("", true),
      (_ctx.mMODEXX == 2 || _ctx.mMODEXX == 3)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 3,
            label: "登録",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fncDBToroku())),
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"}
          }))
        : _createCommentVNode("", true),
      (_ctx.mMODEXX == 1)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 4,
            label: "削除",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fncDBDelete())),
            class: "p-mr-2 p-mt-2",
            style: {"width":"120px"}
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withId(() => [
      _createVNode(_TransitionGroup, {
        name: "z-message",
        tag: "div"
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mMessage, (msg) => {
            return (_openBlock(), _createBlock(_component_zMessage, {
              severity: msg.severity,
              key: msg.id
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(msg.content), 1)
              ]),
              _: 2
            }, 1032, ["severity"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_InputText, {
                id: "dspjun",
                type: "number",
                modelValue: _ctx.mShosaiData.DSPJUN,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mShosaiData.DSPJUN = $event)),
                min: "0",
                max: "9999",
                style: {"width":"80px","text-align":"right"},
                readonly: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3,
                class: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3 ? 'read-only' : ''
              }, null, 8, ["modelValue", "readonly", "class"])
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_Textarea, {
                autoResize: false,
                modelValue: _ctx.mShosaiData.TEKEBU,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.mShosaiData.TEKEBU = $event)),
                maxlength: "500",
                style: {"width":"100%","height":"100px"},
                readonly: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3,
                class: _ctx.mMODEXX != 2 && _ctx.mMODEXX != 3 ? 'read-only' : '' 
              }, null, 8, ["modelValue", "readonly", "class"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
})